export const SITE_CONFIG = {
  name: 'Cântecelul Meu',
  shortName: 'CântecelulMeu',
  domain: 'cantecelulmeu.ro',
  url: 'https://cantecelulmeu.ro',
  description: 'Platformă românească pentru crearea cântecelor personalizate pentru copii',
  author: 'Cântecelul Meu',
  locale: 'ro_RO',
  supportEmail: "support@cantecelulmeu.ro",
  privacyEmail: "privacy@cantecelulmeu.ro",
} as const;